import { Toaster as Sonner, toast } from 'sonner';
import { useTema } from '@/lib/tema';

/** O único sistema de avisos do painel (spec 001). */
export function Toaster() {
  const [tema] = useTema();
  return (
    <Sonner
      theme={tema === 'claro' ? 'light' : tema === 'escuro' ? 'dark' : 'system'}
      position="top-right"
      richColors
      closeButton
      toastOptions={{ classNames: { toast: 'font-sans' } }}
    />
  );
}

export { toast };
